import type { SlideLookupState } from "../types.d";
import type { Ref } from "lit/directives/ref.js";

interface LookupControllerProps {
  windowRef: Ref<HTMLElement>;
}

export class LookupController {
  set contentEl(el: HTMLElement) {
    this._contentEl = el;
  }
  private _contentEl?: HTMLElement;
  private _currentlyShown?: string;
  private _initAnimation = false;
  private _windowRef?: Ref<HTMLElement>;
  constructor({ windowRef }: LookupControllerProps) {
    this._windowRef = windowRef;
  }
  setAnchor() {
    const shownEl = this._contentEl?.querySelector(
      `[data-id="${this._currentlyShown}"]`,
    );

    if (shownEl && this._windowRef?.value) {
      const {
        x: shownX,
        y: shownY,
        width: shownWidth,
        height: shownHeight,
      } = shownEl.getBoundingClientRect();
      const {
        x: windowX,
        y: windowY,
        width: windowWidth,
        height: windowHeight,
      } = this._windowRef.value.getBoundingClientRect();
      const anchorPosition =
        (shownY + shownHeight / 2 < windowY + windowHeight / 2
          ? "bottom-"
          : "top-") +
        (shownX + shownWidth / 2 < windowX + windowWidth / 2
          ? "left"
          : "right");
      shownEl.setAttribute("anchor-position", anchorPosition);
    }
  }
  update({ shown = undefined }: SlideLookupState) {
    setTimeout(() => (this._initAnimation = true), 50);

    if (!this._contentEl) return;

    if (this._currentlyShown === shown) {
      this.setAnchor();

      return;
    }

    if (this._currentlyShown) {
      const shownEl = this._contentEl.querySelector(
        `[data-id="${this._currentlyShown}"]`,
      );
      shownEl?.removeAttribute("show");

      if (this._initAnimation) {
        shownEl?.removeAttribute("no-animation");
      } else {
        shownEl?.setAttribute("no-animation", "");
      }
    }

    if (shown) {
      const shownEl = this._contentEl.querySelector(`[data-id="${shown}"]`);

      if (!shownEl) {
        this._currentlyShown = undefined;

        return;
      }
      shownEl.setAttribute("show", "");

      if (this._initAnimation) {
        shownEl.removeAttribute("no-animation");
      } else {
        shownEl.setAttribute("no-animation", "");
      }
    }
    this._currentlyShown = shown;
    this.setAnchor();
  }
}
